
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guidebook/summary/before/funeral-process",
      function () {
        return require("private-next-pages/guidebook/summary/before/funeral-process.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guidebook/summary/before/funeral-process"])
      });
    }
  